import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule } from '@angular/router';

import { I18nModule } from '@recruitee/i18n';
import { ButtonComponent, HeadingComponent, IconComponent } from '@recruitee/user-interface';

import { AccountSetupRouteReuseStrategy } from './account-setup.route-reuse-strategy';
import { RtoNotFoundComponent } from './not-found/not-found.component';
import { AccountSetupI18nResolver } from './shared/account-setup-i18n-resolver.service';
import { AccountSetupSharedModule } from './shared/shared.module';

@NgModule({
  declarations: [RtoNotFoundComponent],
  providers: [{ provide: RouteReuseStrategy, useClass: AccountSetupRouteReuseStrategy }],
  imports: [
    RouterModule.forRoot(
      [
        {
          path: ':lang',
          resolve: [AccountSetupI18nResolver],
          children: [
            {
              path: ':token/company',
              loadChildren: () =>
                import('./company/company.module').then(m => m.AccountSetupCompanyModule),
            },
            {
              path: ':token/user',
              loadChildren: () => import('./user/user.module').then(m => m.AccountSetupUserModule),
            },
            { path: '404', component: RtoNotFoundComponent },
            { path: '**', redirectTo: '404', pathMatch: 'full' },
          ],
        },
        { path: '**', redirectTo: 'en/404', pathMatch: 'full' },
      ],
      {
        paramsInheritanceStrategy: 'always',
      },
    ),
    I18nModule,
    AccountSetupSharedModule,
    HeadingComponent,
    IconComponent,
    ButtonComponent,
  ],
  exports: [RouterModule],
})
export class RtoAppRoutingModule {}
